import { Dimensions, Quantity, Unit } from '@elderbyte/ngx-starter'
import { Material } from '../../materials/material'

export const newPackageType: () => PackageType = () => {
  const labelingSpec = new PackageTypeLabelingSpec()
  labelingSpec.contentLabelSpecs = []
  const dimensionUnit = Unit.cm
  const weightUnit = Unit.kg
  return <PackageType>{
    labelingSpec,
    supportedPackagingMaterials: [],
    dimensionUnit,
    weightUnit,
    defaultMaxWeight: Quantity.zero(weightUnit),
    defaultMaxDimensions: Dimensions.zero(dimensionUnit),
    presetDimensions: Dimensions.zero(dimensionUnit),
  }
}

export interface PackageType {
  id: string
  name: string
  description: string

  weightUnit: Unit
  dimensionUnit: Unit

  labelingSpec: PackageTypeLabelingSpec

  defaultMaxWeight: Quantity
  defaultMaxDimensions: Dimensions

  materialGroupId: string

  presetDimensions: Dimensions

  supportedPackagingMaterials: PackagingMaterialSpec[]
}

export class PackageTypeLabelingSpec {
  public enabled: boolean
  public template: string
  public contentLabelSpecs: PackageContentLabelSpec[]
}

export class PackageContentLabelSpec {
  constructor(
    public id: string,
    public name: string,
    public template: string,
    public outputOrder: number
  ) {}
}

export const emptyMaterialSpec: () => PackagingMaterialSpec = () =>
  new PackagingMaterialSpec(undefined, undefined)

export class PackagingMaterialSpec {
  constructor(
    public materialId: string,
    public presetQuantity?: number
  ) {}
}

export class PopulatedPackagingMaterialSpec extends PackagingMaterialSpec {
  constructor(
    public override materialId: string,
    public override presetQuantity: number,
    public material: Material
  ) {
    super(materialId, presetQuantity)
  }
}
